import Vue from 'vue'
import VueI18n from 'vue-i18n'
import rus from './rus.js'
import eng from './eng.js'
import deu from './deu.js'

Vue.use(VueI18n)

const messages = {
  en: eng,
  ru: rus,
  de: deu
}

VueI18n.prototype.getChoiceIndex = function (number, choicesLength) {
  number = Math.abs(number) % 100
  let correct_number = number % 10
  if (number > 10 && number < 20) { return 2 }
  if (correct_number > 1 && correct_number < 5) { return 1 }
  if (correct_number == 1) { return 0 }
  return 2
}

export default new VueI18n({
  locale: localStorage.getItem('lh-cp-language') || 'ru',
  messages,
  silentTranslationWarn: process.env.NODE_ENV === 'production'
})


// WEBPACK FOOTER //
// ./src/languages/index.js